import styled from 'styled-components';
import { v2Breakpoints } from './styles/tokens';

export const FooterNav = styled.div`
  max-width: 950px;
  margin: 40px auto 100px;
  padding: 0 10px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 0 7px;

    > .d-flex.justify-content-between {
      flex-direction: column-reverse;
      gap: 10px;
    }

    button.btn-questionnaire {
      width: 100%;
      margin: 0 !important;
    }
  }
`;
